import { render, staticRenderFns } from "./ComplaintSelectTable.vue?vue&type=template&id=058aab50&"
import script from "./ComplaintSelectTable.vue?vue&type=script&lang=js&"
export * from "./ComplaintSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports